import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReportPipelineService } from '@shared/services/report-pipeline.service';

@Component({
  selector: 'mojo-reports-jobs-search-widget',
  styleUrls: ['./reports-jobs-search-widget.component.scss'],
  templateUrl: './reports-jobs-search-widget.component.html',
})
export class ReportsJobsSearchWidgetComponent implements OnInit, OnDestroy {
  @Input() selectedDepartment: string;
  @Input() selectedFunction: string;
  @Input() jobStatus: string;
  @Output() sendCandidateOrHiringManagerName = new EventEmitter();

  private subscription: Subscription = new Subscription();
  form: UntypedFormGroup = new UntypedFormGroup({
    selectedPerson: new UntypedFormControl(''),
  });
  selectedPerson: UntypedFormControl = new UntypedFormControl('');
  constructor(public reportPipelineService: ReportPipelineService) {}

  ngOnInit() {
    this.subscription.add(
      this.form.valueChanges.subscribe((selectedCandidateName) => {
        this.sendCandidateOrHiringManagerName.emit(selectedCandidateName.selectedPerson);
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  loadAutocompleteHiringManagersAndRecruiters(phrase) {
    this.reportPipelineService.triggerAutocomplete(
      phrase,
      this.selectedFunction,
      this.selectedDepartment,
      this.jobStatus,
    );
  }
}
